export default __webpack_public_path__ + "static/media/Download.734fde74.svg";